export default __webpack_public_path__ + "static/media/login.ff752990.jpg";